      // {/* <div className={`why-grid ${inView ? "in-view" : ""}`}>
      //   <div className="why-card">
      //     <img
      //       src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
      //       alt="Quality Standards"
      //     />
      //     <h4>QUALITY STANDARDS</h4>
      //     <p style={{fontSize:16}}>
      //       Technocrat aims at providing the highest quality standards in its
      //       products, making us the number one choice for our prospects.
      //     </p>
      //   </div>

      //   <div className="why-card">
      //     <img
      //       src="https://cdn-icons-png.flaticon.com/512/1077/1077012.png"
      //       alt="Customer Centric"
      //     />
      //     <h4>CUSTOMER CENTRIC</h4>
      //     <p style={{fontSize:16}}>
      //       Customer satisfaction is our utmost priority, and this is what our
      //       entire system and company revolve around.
      //     </p>
      //   </div>

      //   <div className="why-card">
      //     <img
      //       src="https://cdn-icons-png.flaticon.com/512/471/471664.png"
      //       alt="Technical Expertise"
      //     />
      //     <h4>TECHNICAL EXPERTISE</h4>
      //     <p style={{fontSize:16}}>
      //       The team can handle various technical processes and operations
      //       because of our impeccable team of specialized team members.
      //     </p>
      //   </div>

      //   <div className="why-card">
      //     <img
      //       src="https://cdn-icons-png.flaticon.com/512/747/747376.png"
      //       alt="Accessibility"
      //     />
      //     <h4>ACCESSIBILITY</h4>
      //     <p style={{fontSize:16}}>
      //       We provide a user-friendly interface and management for our users,
      //       making us very easily accessible.
      //     </p>
      //   </div>
      // </div> */}

   import React, { useEffect, useRef, useState } from "react";
import "./WhyTechnocratSection.css";

export default function WhyTechnocratSection() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setInView(true);
          else setInView(false);
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="why-section">
      <h2 className="section-title">
        <span className="highlight">Why TAAD</span>
      </h2>

      <div className={`why-content ${inView ? "in-view" : ""}`}>
        <ul className="why-points">
          <li>
            <strong>Faster Time to Qualification:</strong> Accurate simulations
            and turnkey test benches reduce validation cycles and downtime.
          </li>
          <li>
            <strong>Reliability in the Field:</strong> Rugged, maintainable
            designs with lifecycle support for mission readiness.
          </li>
          <li>
            <strong>Custom Engineering:</strong> Tailored subsystems and
            harnessing that integrate seamlessly with legacy and next-gen
            platforms.
          </li>
        </ul>

        {/* <h3 className="why-subheading">Key Offerings at a Glance</h3> */}

        <ul className="why-offerings">
          <li>
            <strong>Avionics:</strong> FDR subsystems, ELT, RIPS, DAQ,
            interfaces.
          </li>
          <li>
            <strong>ISR & Vision:</strong> EO/IR gimbals, handheld thermal
            imagers, ship-borne EO.
          </li>
          <li>
            <strong>UAS:</strong> Tethered drone systems with secure power/data.
          </li>
          <li>
            <strong>Sensors & Switches:</strong> Proximity, hydrostatic, firing
            and control assemblies.
          </li>
          <li>
            <strong>RF/Radar:</strong> Antenna subsystems and RF interconnects.
          </li>
          <li>
            <strong>Test & Validation:</strong> Benches for Navy, Air Force,
            Army; laser inspection.
          </li>
          <li>
            <strong>Cabling:</strong> Aerospace-grade cable-harness and
            connectorized looms.
          </li>
        </ul>
      </div>
    </section>
  );
}
